var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStickyApplicationSidebg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.605,
    height: 260.819,
    viewBox: "0 0 59.605 260.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2188",
    "data-name": "Rectangle 2188",
    width: 59.606,
    height: 260.819,
    transform: "translate(0 0)",
    fill: "#365bb8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1852",
    "data-name": "Mask Group 1852",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2055",
    "data-name": "Group 2055",
    transform: "translate(21.282 16.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2054",
    "data-name": "Group 2054",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2181",
    "data-name": "Rectangle 2181",
    width: 13.461,
    height: 95.829,
    rx: 6.731,
    transform: "translate(0 140.224) rotate(-42)",
    fill: "#ff8b01"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2182",
    "data-name": "Rectangle 2182",
    width: 13.461,
    height: 95.829,
    rx: 6.731,
    transform: "translate(23.303 134.178) rotate(-42)",
    fill: "#fee800"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2183",
    "data-name": "Rectangle 2183",
    width: 13.461,
    height: 95.829,
    rx: 6.731,
    transform: "translate(15.774 94.067) rotate(-42)",
    fill: "#008143"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2184",
    "data-name": "Rectangle 2184",
    width: 13.461,
    height: 95.829,
    rx: 6.731,
    transform: "translate(5.735 52.815) rotate(-42)",
    fill: "#2d87ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2185",
    "data-name": "Rectangle 2185",
    width: 13.461,
    height: 95.829,
    rx: 6.731,
    transform: "translate(28.323 45.354) rotate(-42)",
    fill: "#a03ce9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2186",
    "data-name": "Rectangle 2186",
    width: 13.461,
    height: 95.829,
    rx: 6.731,
    transform: "translate(23.303 9.007) rotate(-42)",
    fill: "#9d11a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2187",
    "data-name": "Rectangle 2187",
    width: 13.461,
    height: 95.829,
    rx: 6.731,
    transform: "translate(9.385 181.111) rotate(-42)",
    fill: "#f91f19"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyApplicationSidebg1);
export default __webpack_public_path__ + "static/media/sticky_application_sidebg1.c62dd99e553852ee1646f45b86dbc5df.svg";
export { ForwardRef as ReactComponent };